import { CoreDataSecurityMonitorsName } from './name';
import { createGetAsyncSlice } from '@sonar-software/xuder';
import { getDataSecurityMonitors } from '@api/data-security/getDataSecurityMonitors';

export const getCoreDataSecurityMonitorsSlice = createGetAsyncSlice({
	name: CoreDataSecurityMonitorsName,
	receive: true,
	request: true,
	requestHandler: getDataSecurityMonitors,
	retainDataOnRequest: true
});
